import { CleanButton, Icon } from '@components/gassan-ui'
import { ModalProps } from '@components/Modal'
import { cn } from '@lib/cn'
import * as Dialog from '@radix-ui/react-dialog'
import { FC, ReactNode } from 'react'

export type FullContentModalProps = Omit<ModalProps, 'title'> & {
  children: ReactNode
}

export const FullContentModal: FC<FullContentModalProps> = ({
  children,
  onOpenChange,
  open,
  defaultOpen,
  triggerButton,
}) => {
  return (
    <Dialog.Root defaultOpen={defaultOpen} open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          className={cn('fixed inset-0 z-[100] h-screen w-screen bg-black', 'md:bg-shade-800/30')}
        >
          <Dialog.Close asChild>
            <CleanButton className={cn('absolute right-4 top-4 z-10', 'md:hidden')}>
              <Icon icon="cross" className="text-white" />
            </CleanButton>
          </Dialog.Close>
          <Dialog.Content
            className={cn(
              'relative left-[50%] top-[50%] -translate-x-1/2 -translate-y-1/2 overflow-y-auto bg-white',
              'md:h-[650px] md:w-[650px]',
              'lg:h-[800px] lg:w-[800px]',
            )}
          >
            <div className="h-full w-full">{children}</div>
            <Dialog.Close asChild>
              <CleanButton className={cn('absolute right-4 top-4 z-10', 'hidden md:block')}>
                <Icon icon="cross" className="text-white" />
              </CleanButton>
            </Dialog.Close>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
